import {
  DigestHighlightsSlice,
  HeroSlice,
  MetadataSlice,
  SliceType,
  isSliceOfType,
} from '../../slices';

import { BuildYourPlan } from './BuildYourPlan';
import { CustomerReviews } from './CustomerReviews';
import { FreshDogFood } from './FreshDogFood';
import { WhyFreshIsBest } from './WhyFreshIsBest';

import type { BreedDocument } from './types';

export interface BreedContentTypeProps {
  document: BreedDocument;
}

export function BreedContentType({ document }: BreedContentTypeProps) {
  const { body } = document.data;
  const breed = document.data.title;

  const heroSlice = body.find(isSliceOfType(SliceType.HeroSlice));
  const metadataSlice = body.find(isSliceOfType(SliceType.MetadataSlice));
  const digestSlice = body.find(isSliceOfType(SliceType.DigestHighlightsSlice));

  return (
    <>
      {metadataSlice && <MetadataSlice slice={metadataSlice} />}
      {heroSlice && <HeroSlice slice={heroSlice} />}
      <FreshDogFood document={document} />
      <WhyFreshIsBest breed={breed} />
      <BuildYourPlan document={document} breed={breed} />
      <CustomerReviews />
      <DigestHighlightsSlice
        slice={digestSlice}
        breed={breed}
        buildId={document.buildId}
      />
    </>
  );
}
